export const FILE_DELIMITER_MAP = {
  COMMA: { label: 'Comma', value: ',' },
  TAB: { label: 'Tab', value: decodeURIComponent('\t') },
  PIPE: { label: 'Pipe', value: '|' },
};

export const FILE_DELIMITER_OPTIONS = Object.values(FILE_DELIMITER_MAP);

export const IMPORT_TYPE_MAP = {
  ONE_TIME: { label: 'One Time Use', value: 1 },
  CREATE_NEW: { label: 'Save New Configuration', value: 2 },
  LOAD_SAVED: { label: 'Use Previous Configuration', value: 3 },
};

export const IMPORT_TYPE_OPTIONS = Object.values(IMPORT_TYPE_MAP);

export const IMAGE_FILE_TYPES = {
  JPG: 'image/jpeg',
  PNG: 'image/png',
};



// WEBPACK FOOTER //
// ./src/common/Constants/file.js